function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module widget/widget
 */
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';
import MouseObserver from '@ckeditor/ckeditor5-engine/src/view/observer/mouseobserver';
import WidgetTypeAround from './widgettypearound/widgettypearound';
import Delete from '@ckeditor/ckeditor5-typing/src/delete';
import { getLabel, isWidget, WIDGET_SELECTED_CLASS_NAME } from './utils';
import { isForwardArrowKeyCode } from '@ckeditor/ckeditor5-utils/src/keyboard';
import env from '@ckeditor/ckeditor5-utils/src/env';
import '../theme/widget.css';
import verticalNavigationHandler from './verticalnavigation';
/**
 * The widget plugin. It enables base support for widgets.
 *
 * See {@glink api/widget package page} for more details and documentation.
 *
 * This plugin enables multiple behaviors required by widgets:
 *
 * * The model to view selection converter for the editing pipeline (it handles widget custom selection rendering).
 * If a converted selection wraps around a widget element, that selection is marked as
 * {@link module:engine/view/selection~Selection#isFake fake}. Additionally, the `ck-widget_selected` CSS class
 * is added to indicate that widget has been selected.
 * * The mouse and keyboard events handling on and around widget elements.
 *
 * @extends module:core/plugin~Plugin
 */

var Widget = /*#__PURE__*/function (_Plugin) {
  _inherits(Widget, _Plugin);

  var _super = _createSuper(Widget);

  function Widget() {
    _classCallCheck(this, Widget);

    return _super.apply(this, arguments);
  }

  _createClass(Widget, [{
    key: "init",
    value:
    /**
     * @inheritDoc
     */
    function init() {
      var _this = this;

      var editor = this.editor;
      var view = editor.editing.view;
      var viewDocument = view.document;
      /**
       * Holds previously selected widgets.
       *
       * @private
       * @type {Set.<module:engine/view/element~Element>}
       */

      this._previouslySelected = new Set(); // Model to view selection converter.
      // Converts selection placed over widget element to fake selection.
      //
      // By default, the selection is downcasted by the engine to surround the attribute element, even though its only
      // child is an inline widget. A similar thing also happens when a collapsed marker is rendered as a UI element
      // next to an inline widget: the view selection contains both the widget and the marker.
      //
      // This prevents creating a correct fake selection when this inline widget is selected. Normalize the selection
      // in these cases based on the model:
      //
      //		[<attributeElement><inlineWidget /></attributeElement>] -> <attributeElement>[<inlineWidget />]</attributeElement>
      //		[<uiElement></uiElement><inlineWidget />] -> <uiElement></uiElement>[<inlineWidget />]
      //
      // Thanks to this:
      //
      // * fake selection can be set correctly,
      // * any logic depending on (View)Selection#getSelectedElement() also works OK.
      //
      // See https://github.com/ckeditor/ckeditor5/issues/9524.

      this.editor.editing.downcastDispatcher.on('selection', function (evt, data, conversionApi) {
        var viewWriter = conversionApi.writer;
        var modelSelection = data.selection; // The collapsed selection can't contain any widget.

        if (modelSelection.isCollapsed) {
          return;
        }

        var selectedModelElement = modelSelection.getSelectedElement();

        if (!selectedModelElement) {
          return;
        }

        var selectedViewElement = editor.editing.mapper.toViewElement(selectedModelElement);

        if (!isWidget(selectedViewElement)) {
          return;
        }

        if (!conversionApi.consumable.consume(modelSelection, 'selection')) {
          return;
        }

        viewWriter.setSelection(viewWriter.createRangeOn(selectedViewElement), {
          fake: true,
          label: getLabel(selectedViewElement)
        });
      }); // Mark all widgets inside the selection with the css class.
      // This handler is registered at the 'low' priority so it's triggered after the real selection conversion.

      this.editor.editing.downcastDispatcher.on('selection', function (evt, data, conversionApi) {
        // Remove selected class from previously selected widgets.
        _this._clearPreviouslySelectedWidgets(conversionApi.writer);

        var viewWriter = conversionApi.writer;
        var viewSelection = viewWriter.document.selection;
        var lastMarked = null;

        var _iterator = _createForOfIteratorHelper(viewSelection.getRanges()),
            _step;

        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var range = _step.value;

            // Note: There could be multiple selected widgets in a range but no fake selection.
            // All of them must be marked as selected, for instance [<widget></widget><widget></widget>]
            var _iterator2 = _createForOfIteratorHelper(range),
                _step2;

            try {
              for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                var value = _step2.value;
                var node = value.item; // Do not mark nested widgets in selected one. See: #57.

                if (isWidget(node) && !isChild(node, lastMarked)) {
                  viewWriter.addClass(WIDGET_SELECTED_CLASS_NAME, node);

                  _this._previouslySelected.add(node);

                  lastMarked = node;
                }
              }
            } catch (err) {
              _iterator2.e(err);
            } finally {
              _iterator2.f();
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }, {
        priority: 'low'
      }); // If mouse down is pressed on widget - create selection over whole widget.

      view.addObserver(MouseObserver);
      this.listenTo(viewDocument, 'mousedown', function () {
        return _this._onMousedown.apply(_this, arguments);
      }); // There are two keydown listeners working on different priorities. This allows other
      // features such as WidgetTypeAround or TableKeyboard to attach their listeners in between
      // and customize the behavior even further in different content/selection scenarios.
      //
      // * The first listener handles changing the selection on arrow key press
      // if the widget is selected or if the selection is next to a widget and the widget
      // should become selected upon the arrow key press.
      //
      // * The second (late) listener makes sure the default browser action on arrow key press is
      // prevented when a widget is selected. This prevents the selection from being moved
      // from a fake selection container.

      this.listenTo(viewDocument, 'arrowKey', function () {
        _this._handleSelectionChangeOnArrowKeyPress.apply(_this, arguments);
      }, {
        context: [isWidget, '$text']
      });
      this.listenTo(viewDocument, 'arrowKey', function () {
        _this._preventDefaultOnArrowKeyPress.apply(_this, arguments);
      }, {
        context: '$root'
      });
      this.listenTo(viewDocument, 'arrowKey', verticalNavigationHandler(this.editor.editing), {
        context: '$text'
      }); // Handle custom delete behaviour.

      this.listenTo(viewDocument, 'delete', function (evt, data) {
        if (_this._handleDelete(data.direction == 'forward')) {
          data.preventDefault();
          evt.stop();
        }
      }, {
        context: '$root'
      });
    }
    /**
     * Handles {@link module:engine/view/document~Document#event:mousedown mousedown} events on widget elements.
     *
     * @private
     * @param {module:utils/eventinfo~EventInfo} eventInfo
     * @param {module:engine/view/observer/domeventdata~DomEventData} domEventData
     */

  }, {
    key: "_onMousedown",
    value: function _onMousedown(eventInfo, domEventData) {
      var editor = this.editor;
      var view = editor.editing.view;
      var viewDocument = view.document;
      var element = domEventData.target; // Do nothing for single or double click inside nested editable.

      if (isInsideNestedEditable(element)) {
        // But at least triple click inside nested editable causes broken selection in Safari.
        // For such event, we select the entire nested editable element.
        // See: https://github.com/ckeditor/ckeditor5/issues/1463.
        if ((env.isSafari || env.isGecko) && domEventData.domEvent.detail >= 3) {
          var mapper = editor.editing.mapper;
          var viewElement = element.is('attributeElement') ? element.findAncestor(function (element) {
            return !element.is('attributeElement');
          }) : element;

          var _modelElement = mapper.toModelElement(viewElement);

          domEventData.preventDefault();
          this.editor.model.change(function (writer) {
            writer.setSelection(_modelElement, 'in');
          });
        }

        return;
      } // If target is not a widget element - check if one of the ancestors is.


      if (!isWidget(element)) {
        element = element.findAncestor(isWidget);

        if (!element) {
          return;
        }
      } // On Android selection would jump to the first table cell, on other devices
      // we can't block it (and don't need to) because of drag and drop support.


      if (env.isAndroid) {
        domEventData.preventDefault();
      } // Focus editor if is not focused already.


      if (!viewDocument.isFocused) {
        view.focus();
      } // Create model selection over widget.


      var modelElement = editor.editing.mapper.toModelElement(element);

      this._setSelectionOverElement(modelElement);
    }
    /**
     * Handles {@link module:engine/view/document~Document#event:keydown keydown} events and changes
     * the model selection when:
     *
     * * arrow key is pressed when the widget is selected,
     * * the selection is next to a widget and the widget should become selected upon the arrow key press.
     *
     * See {@link #_preventDefaultOnArrowKeyPress}.
     *
     * @private
     * @param {module:utils/eventinfo~EventInfo} eventInfo
     * @param {module:engine/view/observer/domeventdata~DomEventData} domEventData
     */

  }, {
    key: "_handleSelectionChangeOnArrowKeyPress",
    value: function _handleSelectionChangeOnArrowKeyPress(eventInfo, domEventData) {
      var keyCode = domEventData.keyCode;
      var model = this.editor.model;
      var schema = model.schema;
      var modelSelection = model.document.selection;
      var objectElement = modelSelection.getSelectedElement();
      var isForward = isForwardArrowKeyCode(keyCode, this.editor.locale.contentLanguageDirection); // If object element is selected.

      if (objectElement && schema.isObject(objectElement)) {
        var position = isForward ? modelSelection.getLastPosition() : modelSelection.getFirstPosition();
        var newRange = schema.getNearestSelectionRange(position, isForward ? 'forward' : 'backward');

        if (newRange) {
          model.change(function (writer) {
            writer.setSelection(newRange);
          });
          domEventData.preventDefault();
          eventInfo.stop();
        }

        return;
      } // If selection is next to object element.
      // Return if not collapsed.


      if (!modelSelection.isCollapsed) {
        return;
      }

      var objectElementNextToSelection = this._getObjectElementNextToSelection(isForward);

      if (objectElementNextToSelection && schema.isObject(objectElementNextToSelection)) {
        this._setSelectionOverElement(objectElementNextToSelection);

        domEventData.preventDefault();
        eventInfo.stop();
      }
    }
    /**
     * Handles {@link module:engine/view/document~Document#event:keydown keydown} events and prevents
     * the default browser behavior to make sure the fake selection is not being moved from a fake selection
     * container.
     *
     * See {@link #_handleSelectionChangeOnArrowKeyPress}.
     *
     * @private
     * @param {module:utils/eventinfo~EventInfo} eventInfo
     * @param {module:engine/view/observer/domeventdata~DomEventData} domEventData
     */

  }, {
    key: "_preventDefaultOnArrowKeyPress",
    value: function _preventDefaultOnArrowKeyPress(eventInfo, domEventData) {
      var model = this.editor.model;
      var schema = model.schema;
      var objectElement = model.document.selection.getSelectedElement(); // If object element is selected.

      if (objectElement && schema.isObject(objectElement)) {
        domEventData.preventDefault();
        eventInfo.stop();
      }
    }
    /**
     * Handles delete keys: backspace and delete.
     *
     * @private
     * @param {Boolean} isForward Set to true if delete was performed in forward direction.
     * @returns {Boolean|undefined} Returns `true` if keys were handled correctly.
     */

  }, {
    key: "_handleDelete",
    value: function _handleDelete(isForward) {
      var _this2 = this;

      // Do nothing when the read only mode is enabled.
      if (this.editor.isReadOnly) {
        return;
      }

      var modelDocument = this.editor.model.document;
      var modelSelection = modelDocument.selection; // Do nothing on non-collapsed selection.

      if (!modelSelection.isCollapsed) {
        return;
      }

      var objectElement = this._getObjectElementNextToSelection(isForward);

      if (objectElement) {
        this.editor.model.change(function (writer) {
          var previousNode = modelSelection.anchor.parent; // Remove previous element if empty.

          while (previousNode.isEmpty) {
            var nodeToRemove = previousNode;
            previousNode = nodeToRemove.parent;
            writer.remove(nodeToRemove);
          }

          _this2._setSelectionOverElement(objectElement);
        });
        return true;
      }
    }
    /**
     * Sets {@link module:engine/model/selection~Selection document's selection} over given element.
     *
     * @protected
     * @param {module:engine/model/element~Element} element
     */

  }, {
    key: "_setSelectionOverElement",
    value: function _setSelectionOverElement(element) {
      this.editor.model.change(function (writer) {
        writer.setSelection(writer.createRangeOn(element));
      });
    }
    /**
     * Checks if {@link module:engine/model/element~Element element} placed next to the current
     * {@link module:engine/model/selection~Selection model selection} exists and is marked in
     * {@link module:engine/model/schema~Schema schema} as `object`.
     *
     * @protected
     * @param {Boolean} forward Direction of checking.
     * @returns {module:engine/model/element~Element|null}
     */

  }, {
    key: "_getObjectElementNextToSelection",
    value: function _getObjectElementNextToSelection(forward) {
      var model = this.editor.model;
      var schema = model.schema;
      var modelSelection = model.document.selection; // Clone current selection to use it as a probe. We must leave default selection as it is so it can return
      // to its current state after undo.

      var probe = model.createSelection(modelSelection);
      model.modifySelection(probe, {
        direction: forward ? 'forward' : 'backward'
      });
      var objectElement = forward ? probe.focus.nodeBefore : probe.focus.nodeAfter;

      if (!!objectElement && schema.isObject(objectElement)) {
        return objectElement;
      }

      return null;
    }
    /**
     * Removes CSS class from previously selected widgets.
     *
     * @private
     * @param {module:engine/view/downcastwriter~DowncastWriter} writer
     */

  }, {
    key: "_clearPreviouslySelectedWidgets",
    value: function _clearPreviouslySelectedWidgets(writer) {
      var _iterator3 = _createForOfIteratorHelper(this._previouslySelected),
          _step3;

      try {
        for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
          var widget = _step3.value;
          writer.removeClass(WIDGET_SELECTED_CLASS_NAME, widget);
        }
      } catch (err) {
        _iterator3.e(err);
      } finally {
        _iterator3.f();
      }

      this._previouslySelected.clear();
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'Widget';
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "requires",
    get: function get() {
      return [WidgetTypeAround, Delete];
    }
  }]);

  return Widget;
}(Plugin); // Returns `true` when element is a nested editable or is placed inside one.
//
// @param {module:engine/view/element~Element}
// @returns {Boolean}


export { Widget as default };

function isInsideNestedEditable(element) {
  while (element) {
    if (element.is('editableElement') && !element.is('rootElement')) {
      return true;
    } // Click on nested widget should select it.


    if (isWidget(element)) {
      return false;
    }

    element = element.parent;
  }

  return false;
} // Checks whether the specified `element` is a child of the `parent` element.
//
// @param {module:engine/view/element~Element} element An element to check.
// @param {module:engine/view/element~Element|null} parent A parent for the element.
// @returns {Boolean}


function isChild(element, parent) {
  if (!parent) {
    return false;
  }

  return Array.from(element.getAncestors()).includes(parent);
}